<template lang="pug">
  button( @click="hideBlock")
    icon( type="arrow-to-up"
      :color="color"
      :size="16"
      class="button cursor-pointer rotating"
      :class="{ toggled: isToggled() }"
    )
</template>

<script>
import { mapState } from 'redux-vuex';
import { Icon } from '@/components/shared-components';
import select from '@/store/selectors';
import { toggleExtendedBlock } from '@/store/actions/visible-components';
import { getForegroundColor } from '@/utils/color';
import store from '../../store';

export default {
  components: {
    Icon,
  },
  data: mapState({
    isVisible: select.components.extendedBlock,
    toggled: !select.components.extendedBlock,
    darkMode: select.customOptions.darkMode,
  }),
  methods: {
    hideBlock() {
      store.dispatch(toggleExtendedBlock(!this.isVisible));
    },
    isToggled() {
      return !this.isVisible;
    },
  },
  computed: {
    color() {
      return getForegroundColor(this.darkMode);
    },
  },
};
</script>

<style lang="scss" scoped>
  .rotating {
    transition: transform 0.21s ease-in-out;
  }

  .toggled {
    transform: rotateZ(180deg);
  }
</style>
